
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { redirectUnauthorizedTo, redirectLoggedInTo, canActivate } from '@angular/fire/compat/auth-guard';
import { VersionControlGuard } from './guards/version-control.guard';
import { MaintenanceGuard } from './guards/maintenance.guard';
import { NewVersionAvailableComponent } from './pages/new-version-available/new-version-available.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth']);
const redirectLoggedInToLayout = () => redirectLoggedInTo(['']);

export const routes: Routes = [
    {
        path: 'new-version',
        component: NewVersionAvailableComponent
    },
    {
        path: 'maintenance',
        loadComponent: () => import('./pages/maintenance/maintenance.component').then(m => m.MaintenanceComponent)
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },
    {
        path: '', 
        loadChildren: () => import('./pages/layout/layout-main.module').then(m => m.LayoutMainModule),
        ...canActivate(redirectUnauthorizedToLogin)
    },
    {
        path: 'auth', 
        loadChildren: () => import('./pages/authentication/authentication.module').then(m => m.AuthenticationModule),
        ...canActivate(redirectLoggedInToLayout)
    },
    {
        path: 'internal-user',
        loadComponent: () => import('./pages/internal-user/internal-user.component').then(m => m.InternalUserComponent),
        ...canActivate(redirectUnauthorizedToLogin),
        canActivate: [VersionControlGuard]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }